export const getLocation = () => {
  return window.location;
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/getLocation.js